import { IRequesterInfo } from "../../../base/models"
import { ClientProxy } from "../../../base/proxy/clientProxy"
import { IPosData } from "../models/models"

export class ListPosDataApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'posTransaction/listPosData',
      requesterInfo,
    })
  }

  public async listPosData(): Promise<IPosData[]> {
    return await this.getAsync<IPosData[]>()
  }
}